import type { ReactNode } from 'react';
import { useI18n } from '@/shared/i18n';
import classes from './AdvancedDiagnosticsPanel.module.css';

export function AdvancedDiagnosticsPanel({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
  /** Reserved for future uncontrolled default; details stays user-toggled. */
  defaultOpen?: boolean;
}) {
  const { t } = useI18n();

  return (
    <details className={classes.root} data-testid="advanced-diagnostics">
      <summary className={classes.summary}>{title ?? t('postingFlow.diagnostics.title')}</summary>
      <div className={classes.body}>{children}</div>
    </details>
  );
}
